module.exports = __webpack_public_path__ + "static/media/icon-produto-alternativo.03bd3444.svg";